module.exports = __webpack_public_path__ + "img/up.aee360f5.png";